if (!customElements.get('expandable-container')) {
  class ExpandableContainer extends HTMLElement {
    constructor() {
      super();
      this.hiddenItems = [];
    }

    connectedCallback() {
      this.button = document.querySelector(`[aria-controls="${this.id}"]`);
      this.items = Array.from(this.querySelectorAll('[data-filter]'));
      this.content = this.querySelector('.expandable__content')
      this.firstItemTop = this.items[0]?.offsetTop || 0;

      if (!this.button || !this.items.length) return;

      this.button.addEventListener('click', this.toggleItems.bind(this));
      this.expanded = false;
    }

    toggleItems() {
      if (this.classList.contains('open')) {
        this.classList.remove('open');
        this.button.setAttribute('aria-expanded', false);
      } else {
        this.classList.add('open');
        this.button.setAttribute('aria-expanded', true);
      }
    }
  }

  customElements.define('expandable-container', ExpandableContainer);
}
